import * as api from './api';
import constants from './constants';
import * as errors from './errors';
import * as functions from './functions';
import * as storage from './storage';
import * as widgetEnvironment from './widgetEnvironment';

export const Payline = {
  api: {
    getBrand: api.getBrand,
    capture: api.capture,
    captureSubscriber: api.captureSubscriber,
    captureSubscriberAfter3DS: api.captureSubscriberAfter3DS,
    createSubscriber: api.createSubscriber,
    subscribeAndCapture: api.subscribeAndCapture,
    captureWithToken: api.captureWithToken,
    getToken: api.getToken,
    checkPayment: api.checkPayment,
    recordWidgetPayment: api.recordWidgetPayment,
  },
  functions,
  errors,
  storage,
  constants,
  widgetEnvironment,
};

export {
 api, functions, errors, storage, widgetEnvironment,
};
export { getActiveWidgetUrl, setActiveWidgetUrl } from './widgetEnvironment';
export { default as constants } from './constants';
export {
 subscribeAndCapture, captureWithToken, checkPayment, recordWidgetPayment,
} from './api';
export {
 PaylineError, handlePaylineError, isPaylineSuccess, safePaylineCall,
} from './errors';
export {
  storeToken,
  getStoredToken,
  deleteStoredToken,
  listStoredTokens,
  formatCardForPayline,
  extractCardMetadata,
  formatCardForDisplay,
} from './storage';
